import { Browser } from '@capacitor/browser';

/* istanbul ignore next -- @preserve */
const openLinkInCortexApp = async (url: string): Promise<void> => {
  await Browser.open({ url });
};

export default openLinkInCortexApp;
